var parent = require('../../stable/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/array/from.js
// module id = 523
// module chunks = 0 1